import { render, staticRenderFns } from "./IndexSeckillList.vue?vue&type=template&id=214dffa5&scoped=true&"
import script from "./IndexSeckillList.vue?vue&type=script&lang=js&"
export * from "./IndexSeckillList.vue?vue&type=script&lang=js&"
import style0 from "./IndexSeckillList.vue?vue&type=style&index=0&id=214dffa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214dffa5",
  null
  
)

export default component.exports